const LogoMarkInline = ({ navy }) => (
  <svg
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    aria-hidden="true"
    className="absolute -top-[15px] left-1/2 -translate-x-1/2"
    style={{ color: navy ? "#1b2a4e" : "#ffffff" }}
  >
    <rect x="2" y="16" width="3.4" height="8" rx="0.6" fill="currentColor" />
    <rect x="7" y="10" width="3.4" height="14" rx="0.6" fill="currentColor" />
    <rect x="12" y="4" width="3.4" height="20" rx="0.6" fill="currentColor" />
    <path d="M0 25.5 C6 18 13 8 20 0 C15 9 9 18 4.5 25.5 Z" fill="url(#cw-swoosh-inline)" />
    <defs>
      <linearGradient id="cw-swoosh-inline" x1="0" y1="26" x2="20" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="currentColor" />
        <stop offset="100%" stopColor="#8E9BBE" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoWordmark = ({ dark = false }) => (
  <span
    className={`font-body font-extrabold tracking-tight text-xl sm:text-2xl leading-none select-none inline-flex items-baseline ${
      dark ? "text-[#1b2a4e]" : "text-white"
    }`}
  >
    COMPLY
    <span className="relative inline-flex items-baseline">
      W
      <LogoMarkInline navy={dark} />
      ISE
    </span>
  </span>
);
